import { useState, useEffect, useCallback } from 'react';
import { ClientBankAccountsApi } from '@/api/clients/client-bank-accounts';

export const useGetClientBankAccount = (
  organizationId,
  accountId,
  options = {},
) => {
  const { enabled = true } = options;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchBankAccount = useCallback(async () => {
    if (!organizationId || !accountId) return;

    setLoading(true);
    setError(null);

    try {
      const response = await ClientBankAccountsApi.getClientBankAccount(
        organizationId,
        accountId,
      );
      setData(response.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch bank account');
      console.error('Error fetching bank account:', err);
    } finally {
      setLoading(false);
    }
  }, [organizationId, accountId]);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    fetchBankAccount();
  }, [fetchBankAccount, enabled]);

  const refetch = () => {
    fetchBankAccount();
  };

  const refresh = () => {
    fetchBankAccount();
  };

  return {
    data,
    loading,
    error,
    refetch,
    refresh,
  };
};
